"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSideNavLink = exports.StyledSideNavTitle = exports.StyledSideNav = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Elements = require("../Elements");

var _helpers = require("../utils/helpers");

var _type = require("../utils/type");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      text-indent: -3px;\n      border-left: 3px solid ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  padding: ", ";\n  ", ";\n  color: ", ";\n  background-color: ", ";\n  border-top: 1px solid ", ";\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n    text-decoration: none;\n    color: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: ", ";\n  ", ";\n  ", ";\n  background-color: ", ";\n  border-top: 1px solid ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 0;\n  border: 1px solid ", ";\n  border-top: none;\n  font-family: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSideNav = _styledComponents.default.aside(_templateObject(), function (props) {
  return props.theme.palette.lightestGray;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.theme.borderRadius;
});

exports.StyledSideNav = StyledSideNav;
var StyledSideNavTitle = (0, _styledComponents.default)(_Elements.CalciteH4)(_templateObject2(), function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 3, '/');
}, (0, _type.avenirRegular)(), (0, _helpers.fontSize)(-1), function (props) {
  return props.theme.palette.offWhite;
}, function (props) {
  return props.theme.palette.lightestGray;
});
exports.StyledSideNavTitle = StyledSideNavTitle;
var StyledSideNavLink = (0, _styledComponents.default)(_Elements.CalciteA)(_templateObject3(), function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 3, '/');
}, (0, _helpers.fontSize)(-2), function (props) {
  return props.theme.palette.darkestGray;
}, function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.theme.palette.lightestGray;
}, function (props) {
  return props.theme.palette.offWhite;
}, function (props) {
  return props.theme.palette.offBlack;
}, function (props) {
  return props.active && (0, _styledComponents.css)(_templateObject4(), function (props) {
    return props.theme.palette.blue;
  });
});
exports.StyledSideNavLink = StyledSideNavLink;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/SideNav/SideNav-styled.js
// module id = 1563
// module chunks = 0